import styled from "@emotion/styled";
import { BackgroundIcon } from "@ui/components/common/background-icon";
import { Button } from "@ui/components/buttons/button";
import { TertiaryButton } from "@ui/components/buttons/tertiary-button";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { CSSProperties, SVGProps } from "react";

interface MessageContainerProps {
	iconSvg: React.FC<SVGProps<SVGElement>>;
	title: string;
	description?: string;
	cta?: { label: string; onClick: () => void };
	secondaryCta?: { label: string; onClick: () => void };
	style?: CSSProperties;
}

export const MessageContainer: React.FC<MessageContainerProps> = ({
	iconSvg: IconSvg,
	title,
	description,
	cta,
	secondaryCta,
	style,
}) => (
	<Container style={style}>
		<BackgroundIcon iconSvg={IconSvg} />
		<Title>{title}</Title>
		<Description className="p-size-s">{description}</Description>
		{cta && <StyledButton label={cta.label} onClick={cta.onClick} />}
		{secondaryCta && <StyledTertiaryButton label={secondaryCta.label} onClick={secondaryCta.onClick} />}
	</Container>
);

const Container = styled.div`
	${stack(undefined, "center", "center")};
	max-width: 500px;
`;

const Title = styled.h3`
	text-align: center;
	margin: 24px 0 8px;
	color: ${colors.grey};
`;

const Description = styled.h3`
	text-align: center;
	color: ${colors.grey};
`;

const StyledButton = styled(Button)`
	margin-top: 24px;
`;

const StyledTertiaryButton = styled(TertiaryButton)`
	margin-top: 24px;
`;
